import showdown from 'showdown';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore -- no types for sanitize-html
import sanitizeHtml from 'sanitize-html';

const converter = new showdown.Converter({
	tables: true,
	simplifiedAutoLink: true,
	strikethrough: true,
	tasklists: true,
	openLinksInNewWindow: true,
	ghCodeBlocks: true
});

const SANITIZE_CFG = {
	allowedTags: [
		'p',
		'br',
		'hr',
		'h1',
		'h2',
		'h3',
		'h4',
		'h5',
		'h6',
		'strong',
		'em',
		'b',
		'i',
		'u',
		's',
		'del',
		'ul',
		'ol',
		'li',
		'a',
		'blockquote',
		'pre',
		'code',
		'table',
		'thead',
		'tbody',
		'tr',
		'td',
		'th',
		'input'
	],
	allowedAttributes: {
		a: ['href', 'target', 'rel'],
		td: ['align'],
		th: ['align'],
		input: ['type', 'checked', 'disabled']
	},
	allowedSchemes: ['http', 'https', 'mailto', 'tel']
};

export const renderMarkdown = (text: string): string => sanitizeHtml(converter.makeHtml(text), SANITIZE_CFG);

const HAS_MD = /[*_#[`\n]|\d+\./;
export const needsDrilldown = (text: string) => text.length > 120 || HAS_MD.test(text);
